export default __webpack_public_path__ + "static/media/stroer_precision_x.e312dfab.svg";